export default __webpack_public_path__ + "static/media/Group 7.1d2e6c38.png";